const shifts = {
  form: {
    information: {
      directionOptions: {
        from: 'מבית הספר',
        to: 'לבית הספר',
        both: 'לבית הספר & מבית הספר',
      },
    },
  },
};

export default shifts;
